var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"content-wrapper"},[(_vm.$slots.header)?_c('a-layout-header',{staticClass:"page-header-wrapper"},[_vm._t("header")],2):_vm._e(),_c('a-layout-content',{staticClass:"content-container"},[_vm._t("default")],2),_c('page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }